import './SourcingHeader.css';
import { useQueryParameters } from 'hooks/url/useQueryParameters';
import IFrameWidgetRenderer from 'components/iframe/IFrameWidgetRenderer';

//
// --- Helper Functions ---

// exported for unit testing only
export const setActiveTabColor = iframe => {
  try {
    const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
    innerDoc.body.style.overflow = 'hidden';

    const subNavTabContainer = innerDoc.getElementById('subnav_suppliers');
    subNavTabContainer.className += ' on';
  } catch (e) {}
};

//
// --- Sourcing Header ---

const SourcingHeader = props => {
  const { isMinimized = false } = props;

  const { offeringKey } = useQueryParameters();

  return (
    <IFrameWidgetRenderer
      className={`supplier-search-sourcing-pa-${isMinimized ? 'shrunken-' : ''}header`}
      data-testid="supplier-search-sourcing-pa-header"
      id="supplier-search-sourcing-pa-header"
      iframeSrc={`/displayBidEventSetupNav.do?offeringID=${offeringKey}`}
      onLoad={setActiveTabColor}
    />
  );
};

export default SourcingHeader;
